export const ourVisionSectionTextContent = {
  headingText: "Our Vision",
  paraText:
    "Our goal is to drive superior performance, uphold integrity, and maintain professionalism in all our actions, with a commitment to becoming the most customer-centric IT service provider. We strive to exceed customer expectations through innovative solutions, reliable support, and a dedication to continuous improvement.",
  btnText: "Contact Us",
};
